export class TenantFolderDto {
  id?: string;
  itemName: string = '';
  description?: string;
  createdAt: Date = new Date();
}
